module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "order-loading-mask"
  }, [_c('div', {
    staticClass: "folder-wrap"
  }, [_c('div', {
    staticClass: "css-folder"
  }, [_c('div', {
    staticClass: "folder-tab",
    class: {
      closed: _vm.isCompleted
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.isCompleted) ? _c('div', {
    staticClass: "file file1"
  }) : _vm._e(), _vm._v(" "), (!_vm.isCompleted) ? _c('div', {
    staticClass: "file file2"
  }) : _vm._e(), _vm._v(" "), (!_vm.isCompleted) ? _c('div', {
    staticClass: "file file3"
  }) : _vm._e(), _vm._v(" "), (_vm.isCompleted) ? _c('div', {
    staticClass: "check"
  }, [_c('svg', {
    staticClass: "check-circle",
    attrs: {
      "viewBox": "0 0 52 52"
    }
  }, [_c('circle', {
    staticClass: "circle",
    attrs: {
      "cx": "26",
      "cy": "26",
      "r": "24",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "checkmark",
    attrs: {
      "fill": "none",
      "d": "M14 27l7 7 16-16"
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "loading-text"
  }, [_vm._v(_vm._s(_vm.isCompleted ? _vm.doneText : _vm.text))]), _vm._v(" "), (_vm.showProgress) ? _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('div', {
    staticClass: "progress-container"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.isCompleted ? '100%' : _vm.progressPercent + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "progress-percent"
  }, [_vm._v(_vm._s(_vm.isCompleted ? 100 : _vm.progressPercent) + "%")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-body"
  }, [_c('div', {
    staticClass: "folder-label"
  }, [_vm._v("空气虫档案夹")]), _vm._v(" "), _c('div', {
    staticClass: "folder-lines"
  }, [_c('div', {
    staticClass: "folder-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "folder-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "folder-line"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-631609bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/loading/orderRecreatingLoading.vue
// module id = 1015
// module chunks = 3